module.exports = __webpack_public_path__ + "static/media/Linkdownload.bf087b71.svg";